import {useTranslation} from 'react-i18next';
import StatusLabel, {StatusColor} from '../StatusLabel/StatusLabel';
import {useEntranceStatus} from './useEntranceStatus';
import {EntranceState} from './entranceStatus.utils';
import {formatCountdown} from '../../../library/dates';
import ticketCanceledImg from '../../../assets/images/eTicket/ticketCanceled.png';

const SECONDS_IN_DAY = 24 * 60 * 60;

interface StateConfig {
    color: StatusColor;
    textKey: string;
    image?: string;
    imageHeight?: string;
    imageRotate?: string;
    desaturate?: boolean;
}

const stateConfig: Record<EntranceState, StateConfig> = {
    canceled: {color: 'canceled', textKey: 'statusCanceled', image: ticketCanceledImg, imageHeight: '67.353px', imageRotate: '13.998deg'},
    today: {color: 'highlight', textKey: 'statusToday'},
    countdown: {color: 'highlight', textKey: 'statusCountdown'},
    tomorrow: {color: 'brand', textKey: 'statusTomorrow'},
    past: {color: 'past', textKey: 'statusPast', image: 'https://static.tickchak.co.il/images/app/eTicket/pastEventExpired.png', imageHeight: '50.507px', imageRotate: '10.872deg', desaturate: true}
};

function EntranceTicketStatus() {
    const {t} = useTranslation('eTicket');
    const {state, remainingSec} = useEntranceStatus();
    if(!state)
        return null;

    const {color, textKey, image, imageHeight, imageRotate, desaturate} = stateConfig[state];
    const days = Math.floor(remainingSec / SECONDS_IN_DAY);
    const restSec = remainingSec % SECONDS_IN_DAY;
    const countdown = days > 0 ? `${days}:${formatCountdown(restSec)}` : formatCountdown(restSec);
    const text = state === 'countdown' ? `${t(textKey)} ${countdown}` : t(textKey);

    return (
        <StatusLabel
            color={color}
            text={text}
            image={image}
            imageHeight={imageHeight}
            imageRotate={imageRotate}
            desaturate={desaturate}
            data-cy="entrance-ticket-status"
        />
    );
}

export default EntranceTicketStatus;
